<script setup lang="ts">
const { state: myself } = useSelf()
const { logOut } = useAuthentication()
const { navigateToOnboarding } = useNavigation()
const { sidebarUserDropdownTestId } = useTestId()
const { state: sidebarState, showSidebarAndPersist, hideSidebarAndPersist } = useSidebar()

function openFeedback() {
  navigateTo(
    "mailto:hello@withpoly.com",
    { external: true, open: { target: "_blank" } },
  )
}
function openSettings(close: () => void) {
  close()
  navigateTo("/settings")
}

function hideSidebarAndClose(close: () => void) {
  close()
  hideSidebarAndPersist()
}
</script>

<template>
  <dropdown
    anchor-x="left"
    anchor-y="bottom"
    flow-x="right"
    flow-y="down"
    class="avatar-dropdown"
  >
    <template #default="{ toggle }">
      <user-avatar
        :user="myself.user"
        class="user-avatar"
        :size="24"
        @click="toggle()"
      />
    </template>
    <template #menu="{ close }">
      <dropdown-menu class="avatar-dropdown-menu" :data-testid="sidebarUserDropdownTestId">
        <menu-section>
          <menu-header :label="myself.user?.email() || ''" />
          <dropdown-item @click="openSettings(close)">
            <div>Settings</div>
          </dropdown-item>
          <dropdown-item @click="logOut()">
            <div>Logout</div>
          </dropdown-item>
        </menu-section>
        <menu-separator />
        <menu-section>
          <dropdown-item v-if="sidebarState.state" @click="hideSidebarAndClose(close)">
            <div>Hide Sidebar</div>
          </dropdown-item>
          <dropdown-item v-else @click="showSidebarAndPersist()">
            <div>Show Sidebar</div>
          </dropdown-item>
        </menu-section>
        <menu-separator />
        <menu-section>
          <dropdown-item @click="navigateToOnboarding()">
            <div>Onboarding</div>
          </dropdown-item>
          <dropdown-item @click="openFeedback()">
            <div>Feedback</div>
          </dropdown-item>
          <dropdown-item @click="navigateTo('/join-discord')">
            <div>Discord</div>
          </dropdown-item>
        </menu-section>
      </dropdown-menu>
    </template>
  </dropdown>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.user-avatar
  @apply cursor-pointer

.avatar-dropdown
  app-region: no-drag
  @apply z-navigation-layer

.avatar-dropdown-menu
  @apply my-2
</style>
